import {Typography} from '@sollapay/ui/components';
import {AccountCardIcon} from '@sollapay/ui/icons';
import {TrustAccountNumberChip} from '@sollapay/web-core';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

/** `row` (the default) is the masked chip a list row or card reveals; `labeled` the header meta-row item. */
export interface TrustAccountNumberProps {
  refId: string;
  variant?: 'row' | 'labeled';
}

export const TrustAccountNumber: FC<TrustAccountNumberProps> = ({refId, variant = 'row'}) => {
  const {t} = useTranslation('trustAccounts');
  const label = t('accountNumber.label');

  if (variant !== 'labeled') {
    return (
      <TrustAccountNumberChip
        refId={refId}
        fieldName={label}
        size="sm"
        weight="regular"
        masked
        revealOnRowHover
      />
    );
  }

  return (
    <div className="flex shrink-0 items-center gap-2">
      <AccountCardIcon data-slot="icon" className="h-auto w-5.5 shrink-0" />
      <Typography as="span" size="xs" color="tertiary">
        {label}
      </Typography>
      <TrustAccountNumberChip refId={refId} fieldName={label} showIcon={false} weight="regular" />
    </div>
  );
};
